import { Controller } from "@hotwired/stimulus"

// Blocks an assessment (Course Test / Evaluation) submission until every
// question is answered, marking each unanswered question with an inline error
// that clears as soon as the learner answers it.
export default class extends Controller {
  static targets = ["question", "errorTemplate"]

  submit(event) {
    const unanswered = this.questionTargets.filter((question) => !this.answered(question))
    this.questionTargets.forEach((question) => this.clearError(question))
    if (unanswered.length === 0) return

    event.preventDefault()
    unanswered.forEach((question) => this.showError(question))
    unanswered[0].scrollIntoView({ behavior: "smooth", block: "center" })
  }

  clear(event) {
    const question = event.target.closest("[data-academy-assessment-target='question']")
    if (question && this.answered(question)) this.clearError(question)
  }

  answered(question) {
    const choiceInputs = question.querySelectorAll(".academy-quiz-option-input")
    if (choiceInputs.length > 0) {
      return Array.from(choiceInputs).some((input) => input.checked)
    }

    const openInput = question.querySelector(".academy-quiz-open-input")
    return openInput ? openInput.value.trim() !== "" : true
  }

  showError(question) {
    if (question.classList.contains("is-unanswered")) return

    question.classList.add("is-unanswered")
    question.appendChild(this.errorTemplateTarget.content.cloneNode(true))
  }

  clearError(question) {
    question.classList.remove("is-unanswered")
    question.querySelector(".academy-quiz-question-error")?.remove()
  }
}
